require('@babel/polyfill');

const environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = Object.assign({
  CONN_STATUS_CHANGE: '701',
  ERROR_MSG: '1',
  ACC_BAL_UPDATE: '601',
  BM_HOLIDAY: 605,
  MSG_TO_TRD: '2',
  UPDATE_STOCK: '709',
  UPDATE_CUST_MARGIN: '708',
  TRD_MASTER_CNG: '702',
  KILL_TRD_SES: '11',
  FORCED_LOGOUT: '12',
  INITIAL_CHECKS_FAILED: '106',
  MARGIN_CHECKS_FAILED: '107',
  FWD_NORATES_STREAM: '108',
  FWD_ORD_REJECT: '112',
  NEWS_FEED: '5',
  END_OF_DAY: '609',
  FAILED: 100,
  EXCEEDS_EXPOSURE: 101,
  INSUFFICIENT_MRG: 102,
  EXCEEDS_TRDLIMIT: 103,
  EXCEEDS_ORDLIMIT: 104,
  TRD_PROCESS_ISSUE: 105,
  NO_DEALER: 106,
  TRD_DISABLED: 107,
  TRD_ROUTE_ISSUE: 108,
  SESSION_EXP: 109,
  TRD_PLACE_FAIL: 110,
  // REQ_CONF_MRG :111,
  REQ_CONF_TRD: 112,
  MRK_ORD_CACNEL: 602,
  ORD_NOT_OST: 113,
  WAIT_FOR_CANC_CONF: 114,
  ORD_PROCEED: 115,
  INVALID_DATE: 116,
  REJ_ACCLOCKED: 117,
  EXCEEDS_MIN_QTYLIMIT: 118,
  HEDGE_REJECT: 119,
  NOP_BREACH: 120,
  WORST_NOP_BREACH: 121,
  BM_NOT_VALID: 122,
  SUCCESS: 200,
  INPROCESS: 205,
  MRG_FAILED: 300,
  MRG_SUCCESS: 400,
  PRC_MOVED: 500,
  DEAL_FAIL_STALE_PRC: 600,
  ORD_FILLED: 601,
  LOOP_ORDER_FAILED: 606,
  TRADE_REQUEST_RECEIVED: '102',
  TRADE_REQUEST_REJCTED: '104',
  ORDER_REQUEST_REJECT: '210',
  REQUEST_REJECT: '202',
  TRADE_REQUEST_CONFIRMED: '103',
  UPDATE_FNC_RMK : '818',
  TRADER_BUY: 1,
  TRADER_SELL: 0,
  ORD_REQ_RECD: '201',
  ORD_PLACED: '206',
  ORD_ACTIVATED: '231',
  MODIFY_REQ_RECD: '204',
  ORD_MODIFIED: '207',
  ORD_CANCEL: '208',
  ORD_CANCEL_REQUEST: '205',
  ORD_UNHEDGE_FILL: '219',
  ORDER_EXPIRED: '212',
  HEGDGE_SETT_CHNG: '704',
  ORDER_UNHEDGE_EXPIRED: '226',
  ORDER_PARTIALLY_FILL_CANCEL: '229',
  OCO_PARTIALLY_FILL_CANCEL: '230',
  ORD_HEDGE_FILL: '209',
  BENCHMARK_REQ_RECD: '301',
  BENCHMARK_MOD_REQ_RECD: '302',
  BENCHMARK_CANC_REQ_RECD: '303',
  BM_PLACED: '304',
  BM_MODIFIED: '305',
  BM_CANCELLED: '306',
  BENCHMARK_MANUAL_FILL: '307',
  BM_REJECTED: '308',
  BENCHMARK_CUTOFF: '309',
  BENCHMARK_REQ_FAILED: '310',
  INVALID_BENCHMARK_REQUEST: '311',
  AVGBMK_ORDER_PLACED: "316",
  AVGBMK_ORDER_MODIFIED: "317",
  AVGBMK_ORDER_CANCELLED: "318",
  AVGBMK_REVERSE_REBOOK: "320",
  UPDATE_VALUE_DATE: '711',
  UPDATE_ADJUSTMENT_DEALER: '713',
  UPDATE_BMDETAILS: '705',
  // UPDATE_PR_LOCATION:'804',
  UPDATE_PR_SSI: '804',
  PAYMENT_REQUEST_PLACED: '805',
  PAYMENT_REQ_UPDATE: '806',
  PAYMENT_REQUEST_APRVREJ: '807',
  PAYMENT_REQUEST_FAIL: '808',
  UPDATE_PR_CUTOFF: '809',
  UPDATE_HOLIDAY: '810',
  ADD_PMR_HOLIDAY: '811',
  DELETE_PMR_HOLIDAY: '812',
  OCO_ORD_BCM: '815',//use only for notification popup
  UPDATE_SWAP_RATE: '614',
  WS_RECONNECT: '615',
  UPDATE_MARKUP: '604',//update markup
  UPDATE_EFP: '602',
  NEWORD: 1,
  MODORD: 2,
  EXPIREDORD: 3,
  CANCELORD: 6,
  GTD: 6,
  GTC: 1,
  DAY: 0,
  TRD_LOGIN: '7',
  TRD_LOGOUT: '8',
  DEAL_CONFM: '13',
  NO_PRICE: 207,
  BMK_ORD_TYPE: 0,
  LMT_ORD_TYPE: 2,
  STOP_ORD_TYPE: 3,
  OCO_ORD_TYPE: 6,
  OTO_ORD_TYPE:7,
  PARTIAL_FILL:4,
  FINAL_FILL:5,
  FILL_UNHEDGE_ORD:10,
  milliSecDateFormat: 'YYYY/MM/DD HH:mm:ss.SSS',
  validityDateFormat: 'YYYY-MM-DD HH:mm',
  shortDateFormat: 'DD-MMM-YY',
  rptDateFormat: 'DD-MMM-YY',
  actTimeDateTimeFormatter: 'YYYY-MM-DD HH:mm:ss.SSS',
  dmyFmt: 'YYYY-MM-dd',
  ddmmFmt: 'MM-dd',
  lastloginDateFrmat: 'YYYY-MM-DD HH:mm:ss.SSS',
  paymentDateFormat: 'YYYY/MM/DD',
  HB_ACK: '20',
  TRADING_STATUS_CHANGED: '101',
  FORWARD_SETTING_CHANGED: '618', // forward setting changed from dealer
  FIX_RATE_SUBSCRIPTION_REJECTED: '910',
  DEFAULT_ACC_CHANGE:'912', //bug AZ#326884 FD#18768
  FWD_BMK_PERCENTAGE_UPDATE: '621' 
}, environment);
